import { primary } from 'hfty-styles/src/colors'

const styles = {
  h3: {
    fontSize: '22px',
    margin: '0 0 10px 0',
    color: primary(),
  },
}

export default styles
